import { Stack, Typography } from '@mui/material';
import PageCableDisconnected from 'illustrations/PageCableDisconnected';
import React from 'react';
import { NoAccessReason } from 'types/access';

const NoAuthView: React.FC<{ noAccessReason: NoAccessReason | null }> = ({
	noAccessReason
}) => {
	let title = '';
	let message = '';

	switch (noAccessReason) {
		case NoAccessReason.APP_DISABLED:
			title = intl.tr('noAuthView.appDisabled.title');
			message = intl.tr('noAuthView.appDisabled.message');
			break;
		case NoAccessReason.APP_LOAD_ERROR:
			title = intl.tr('noAuthView.appLoadError.title');
			message = intl.tr('noAuthView.appLoadError.message');
			break;
		case NoAccessReason.USER_NOT_LOGGED_IN:
			title = intl.tr('noAuthView.userNotLoggedIn.title');
			message = intl.tr('noAuthView.userNotLoggedIn.message');
			break;
		case NoAccessReason.TENANT_SELECTION_FAILED:
			title = intl.tr('noAuthView.tenantSelectionFailed.title');
			message = intl.tr('noAuthView.tenantSelectionFailed.message');
			break;
		case NoAccessReason.NO_AUTH:
			title = intl.tr('noAuthView.noAuth.title');
			break;
		case NoAccessReason.UNKNOWN_PROJECT:
			title = intl.tr('noAuthView.unknownProject.title');
			message = intl.tr('noAuthView.unknownProject.message');
			break;
		/* istanbul ignore next  */
		default:
			title = intl.tr('noAuthView.unknownProject.title');
			message = intl.tr('noAuthView.unknownProject.message');
			break;
	}

	return (
		<Stack
			data-testid="no-auth-view"
			direction="column"
			alignItems="center"
			height="100%"
			gap={2}
			mt={10}
		>
			<PageCableDisconnected height="30%" />
			<Typography variant="h4">{title}</Typography>
			{message && <Typography variant="body1">{message}</Typography>}
		</Stack>
	);
};

export default NoAuthView;
